import { withInstall } from '@sgui-plus/utils/with-install'

import Col from './src/col'

export const SgCol = withInstall(Col)
export default SgCol

export * from './src/col'
